/**
 * Shared pieces of the non-production marks (#1099). Production never uses
 * any of these: every caller picks them only when `environmentMarkLabel()`
 * returns a label, so PROD keeps its exact classes and DOM.
 */

/** CSS variable holding the banner's rendered height (0 when absent). */
export const ENV_BANNER_HEIGHT_VAR = "--env-banner-height";

/** Amber accent for the sidebar header, the top bar of the signed-in layouts. */
export const ENV_HEADER_ACCENT_CLASS =
  "flex-wrap gap-y-2 border-b-4 border-b-amber-500 bg-amber-100 dark:bg-amber-950/60";

/**
 * Keeps the fixed mobile menu toggle (normally `top-4`) below the banner,
 * which pushes the page down but not fixed elements.
 */
export const ENV_MOBILE_TOGGLE_TOP_CLASS = "top-[calc(1rem+var(--env-banner-height,0px))]";

/** sonner's default top offsets (24px, 16px on mobile) plus the banner. */
export const ENV_TOASTER_OFFSETS = {
  offset: { top: "calc(24px + var(--env-banner-height, 0px))" },
  mobileOffset: { top: "calc(16px + var(--env-banner-height, 0px))" },
};
